
  <template>
    <div>
      <div class="sayfahead m-0">
        <h1><img src="https://cdn.mudu.pro/Design/asansorcrm.svg" style="height: 20px"> <small>Asansör Entegrasyon
          <sup :class="Kurulum?'text-success':'text-danger'">
            <b>{{ this.$store.getters.SubDomain }}-{{ Bina_id }}</b>
          </sup>
        </small>

        </h1>
        <el-button-group class="float-right">

        </el-button-group>
      </div>

      <div class="TanitimBlok">
        <br>
        <h4>Asansör Crm Entegrasyonu</h4>
        <h5>Anlaşmalı asansör firmanız ile Entegre olun</h5>
        <h6>Asansör bakımlarınızda anlık yönetici bildirimi ve ücretsiz olarak Aidatım üzerinden takip edilmesi için asansör firmanızın bizimle iletişime geçmesini sağlayabilirsiniz.</h6>
        <a target="_blank" class="el-button el-button--small el-button--warning"
           href="https://asansorcrm.com/">
          Asansör Crm Kullanan Firmalar
        </a>
      </div>
    </div>

  </template>

  <script>
    export default {
      props: ['Bina_id'],
      data() {
        return {
          Kurulum: false
        }
      }
    }
  </script>

  <style scoped>

  </style>






// WEBPACK FOOTER //
// src/components/Pack/Yonetim/bina/Tab/BinaAsansor.vue